import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-manquement-recours',
    templateUrl: './manquement-recours.component.html',
    styleUrls: ['./manquement-recours.component.scss'],
    standalone: false
})
export class ManquementRecoursComponent {
    constructor(public readonly modal: NgbActiveModal) {}

    /**
     * Confirmer la modification du resultat du controle
     */
    onTerminer() {
        this.modal.close();
    }
}
